import React from 'react'
import { EnumDialogs, useDialogStore } from "services/store/dialog-store"
import { DialogAutenticarSenha } from "../dialog-autenticar-senha/dialog-autenticar-senha";
import { DialogSelecionarMesa } from '../dialog-selecionar-mesa/dialog-selecionar-mesa';
import { EnumModals, useModalStore } from 'services/store/modal-store';
import { HistoricoPedidosModal } from 'components/modals/historico-pedidos/historico-pedidos-modal';
import { ResumoPedidoModal } from 'components/modals/resumo-pedido';
import { DialogSelecionarContrato } from '../dialog-selecionar-contrato/dialog-selecionar-contrato';
import { DialogPerfil } from '../dialog-perfil/dialog-perfil';
import { DialogAutenticarCliente } from '../dialog-autenticar-cliente/dialog-autenticar-cliente';
import { DialogSelecionarEmpresa } from '../dialog-selecionar-empresa/dialog-selecionar-empresa';

export const DialogModais = () => {
    const { dialogs } = useDialogStore(state => state);
    const { modals } = useModalStore(state => state);

    return <>
        {dialogs[EnumDialogs.Autenticar].aberto && (
            <DialogAutenticarSenha
                aberto={dialogs[EnumDialogs.Autenticar].aberto}
                {...dialogs[EnumDialogs.Autenticar].props}
            />
        )}
        {dialogs[EnumDialogs.AutenticarCliente].aberto && (
            <DialogAutenticarCliente
                aberto={dialogs[EnumDialogs.AutenticarCliente].aberto}
                {...dialogs[EnumDialogs.AutenticarCliente].props}
            />
        )}
        {dialogs[EnumDialogs.Perfil].aberto && (
            <DialogPerfil
                aberto={dialogs[EnumDialogs.Perfil].aberto}
                {...dialogs[EnumDialogs.Perfil].props}
            />
        )}

        {dialogs[EnumDialogs.SelecionarMesa].aberto && (
            <DialogSelecionarMesa
                aberto={dialogs[EnumDialogs.SelecionarMesa].aberto}
                {...dialogs[EnumDialogs.SelecionarMesa].props}
            />
        )}
        {dialogs[EnumDialogs.SelecionarContrato].aberto && (
            <DialogSelecionarContrato
                aberto={dialogs[EnumDialogs.SelecionarContrato].aberto}
                {...dialogs[EnumDialogs.SelecionarContrato].props}
            />
        )}
        {dialogs[EnumDialogs.SelecionarEmpresa].aberto && (
            <DialogSelecionarEmpresa
                aberto={dialogs[EnumDialogs.SelecionarEmpresa].aberto}
                {...dialogs[EnumDialogs.SelecionarEmpresa].props}
            />
        )}
        <HistoricoPedidosModal
            aberto={modals[EnumModals.HistoricoPedidos].aberto}
            {...modals[EnumModals.HistoricoPedidos].props}
        />
        <ResumoPedidoModal
            aberto={modals?.[EnumModals.ResumoPedido].aberto}
            {...modals[EnumModals.ResumoPedido].props}
        />

    </>
}